export default {
      id: "as-facilities-for-assistance-dogs-usage",
      viewBox: "0 0 56 56",
      url: "/" + "sprite.svg#as-facilities-for-assistance-dogs",
      toString: function () {
        return this.url;
      }
    }